import { useRef, useState } from "react";
import { useToggleWithNavigation } from "@edreamsodigeo/prisma-design-system";
import { useFlow } from "@edreamsodigeo/frontend-core";

interface OpenHook {
  (
    initialState?: boolean,
  ): [isOpen: boolean, setOpen: (state: boolean) => void];
}

const useDesktopOpen = (initialState): ReturnType<OpenHook> => {
  const [isOpen, setOpen] = useState(initialState);
  return [isOpen, setOpen];
};

const useMobileOpen = (initialState): ReturnType<OpenHook> => {
  const { isOpen, open, close } = useToggleWithNavigation();
  const isAlreadyOpened = useRef(false);

  if (initialState && !isAlreadyOpened.current) {
    open();
    isAlreadyOpened.current = true;
  }

  const setOpen = (state: boolean): void => {
    if (state) {
      open();
    } else {
      close();
    }
  };

  return [isOpen, setOpen];
};

const useOpenByDevice: OpenHook = (initialState = false) => {
  const flow = useFlow();
  const useDeviceHook = flow === "mobile" ? useMobileOpen : useDesktopOpen;

  return useDeviceHook(initialState);
};

export default useOpenByDevice;
